import { Mapper } from "../../../../base/utils/mapper";
import { TeleconsultaInsertResponseModel } from "../../../../domain/models/consult/teleconsulta-insert-response.model";
import { TeleconsultaInsertResponseEntity } from "../entities/teleconsulta-insert-response.entity";

export class TeleconsultaInsertImplementationRepositoryMapper extends Mapper<TeleconsultaInsertResponseEntity, TeleconsultaInsertResponseModel> {
    mapFrom(param: TeleconsultaInsertResponseEntity): TeleconsultaInsertResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TeleconsultaInsertResponseModel): TeleconsultaInsertResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
